import "./LoadMask.scss";

function LoadMask({ show, message }) {
	return (
		<div className={["load-mask", show && "show"].filter(f=>f).join(" ")}>
			<div className="loading-text">
				{ message ?? <>Loading</> }
				<span className="load__dot">.</span>
				<span className="load__dot">.</span>
				<span className="load__dot">.</span>
			</div>
			
		</div>
	);
}

export default LoadMask;
